<template>
  <div  class="results-table__data-wrapper">
    <div  
      class="results-table__row table-flex-row"
      v-for="(row, k) in tableData"
      :key="k"
    >
      <template v-for="(cell, l) in tableConfig">
        <data-cell
          :v-if="cell.type !== 'template'"
          class="table-flex-data-cell"      
          :key="`cell_${k}_${l}`"
          :doc-data="row"
          :cell-info="cell"
          :style="cell.style"
        />

        <div
          v-if="cell.type === 'template'"
          class="table-flex-data-cell"
          :key="`slot_${k}_${l}`"
          :style="cell.style"
        >
          <slot 
            :name="cell.name"
            :data="{row, cell}"
          />        
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import DataCell from './DataRowCell'

export default {
  components: {
    DataCell
  },

  props: {
    tableConfig: {
      type: Array,
      required: true
    },
    tableData: {
      type: Array,
      required: true
    }
  }
};
</script>
